var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpkinSeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#C9944E;}\n\t.st2{fill:#FFE3B2;}\n\t.st3{fill:#F0C15E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.95,69.2c-3.41-0.39-6.61-1.33-9.3-2.96h0c-1.61-0.98-4.12,0.23-4.36,2.1l0,0 c-0.02,0.16-0.05,0.31-0.08,0.47c2.6,1.49,5.65,2.36,8.89,2.73c10.53,1.2,22.02,10.52,28.79,24.6c8.4,17.44,6.59,35.98-3.72,43.2 c0.86-0.25,1.7-0.57,2.52-0.97c12.33-5.94,15.04-25.89,6.05-44.57C100.96,79.72,89.47,70.4,78.95,69.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.89,96.13c-6.78-14.08-18.27-23.4-28.79-24.6c-3.24-0.37-6.29-1.24-8.89-2.73 c-0.46,2.96-1.68,5.89-3.41,8.65c-5.63,8.98-5.5,23.77,1.28,37.85c8.4,17.44,24.02,27.59,36.09,24.03 C109.48,132.11,111.29,113.57,102.89,96.13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.83,71.36c0.91-0.82,1.7-1.77,2.34-2.85c-1.99-0.51-3.86-1.26-5.54-2.28h0c-1.61-0.98-4.12,0.23-4.36,2.1 l0,0c-0.02,0.16-0.06,0.31-0.08,0.47C67.47,70.09,70.06,70.93,72.83,71.36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.61,74.08c2.29,0.31,4.57,0.02,6.65-0.99c0.95-0.46,1.81-1.05,2.58-1.73c-2.77-0.44-5.37-1.27-7.63-2.56 C64.92,70.58,64.38,72.35,63.61,74.08z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.11,84.2c4.66,13.98,9.29,28.01,17.42,40.43c1.64,2.51,3.43,4.92,5.11,7.41 c-7.06-2.95-12.77-9.05-16.51-15.6c-4.2-7.25-6.58-15.64-6.76-24.02C66.31,89.7,66.41,86.84,67.11,84.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.28,88.83c-1.92-2.85-3.28-5.89-3.79-9v0c-0.3-1.86-2.85-2.98-4.43-1.95l0,0 c-0.13,0.09-0.27,0.16-0.41,0.25c0.56,2.95,1.87,5.83,3.69,8.53c5.92,8.79,6.29,23.58-0.02,37.87 c-7.81,17.71-23.09,28.38-35.27,25.22c0.75,0.49,1.54,0.92,2.37,1.29c12.52,5.52,29.46-5.37,37.82-24.34 C159.57,112.41,159.21,97.61,153.28,88.83z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.34,124.53c6.3-14.29,5.94-29.08,0.02-37.87c-1.82-2.7-3.13-5.59-3.69-8.53c-2.55,1.57-5.57,2.55-8.79,3.03 c-10.48,1.55-21.65,11.25-27.96,25.55c-7.81,17.71-5.39,36.18,5.16,43.05C125.26,152.9,140.53,142.23,148.34,124.53z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.67,85.59c1.21,0.16,2.45,0.14,3.69-0.07c-0.9-1.85-1.55-3.76-1.86-5.69v0c-0.3-1.86-2.85-2.98-4.43-1.95 l0,0c-0.13,0.09-0.27,0.16-0.41,0.24C145.15,80.68,146.2,83.2,147.67,85.59z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.61,80.33c1.25,1.94,2.95,3.48,5.07,4.42c0.97,0.43,1.97,0.7,2.99,0.83c-1.47-2.39-2.52-4.91-3.01-7.47 C143.13,79.06,141.43,79.8,139.61,80.33z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.19,89.56c-7.6,12.62-15.27,25.25-19.44,39.5c-0.84,2.88-1.52,5.8-2.32,8.69 c-2.4-7.47-1.33-15.91,1.31-23.16c2.82-7.71,7.58-14.8,13.71-20.26C129.49,92.52,131.73,90.75,134.19,89.56z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkinSeeds);
export default __webpack_public_path__ + "static/media/Pumpkin_seeds.20a5c7680cc22c65cc84cfe9e940a412.svg";
export { ForwardRef as ReactComponent };